import { Outlet, redirect } from '@tanstack/react-router';
import { Spin } from 'antd';

// import { useBeforeUnload } from 'react-use';

import '@/routes/arc/styles/index.scss';
import { BackgroundTask } from '@/routes/arc/widgets/arc-background-task/BackgroundTask.tsx';
import ArcHeader from '@/routes/arc/widgets/arc-header/ArcHeader.tsx';
import OperatorStatusUpdateForm from '@/routes/arc/widgets/operator-status-update-form/OperatorStatusUpdateForm.tsx';
import RejectCallReasonForm from '@/routes/arc/widgets/reject-call-form/RejectCallReasonForm.tsx';
import { useHostInitialized } from '@/stores/host.store.tsx';
import { useUserStore } from '@/stores/user.store.ts';
import { Host } from '@/widgets/hosts/Host.tsx';

export const Route = createFileRoute({
  component: ARCLayout,
  beforeLoad: async () => {
    // check user auth
    const user = useUserStore.getState().user;
    if (!user?.accessToken) {
      return redirect({ to: '/auth/sign-in' });
    }
  },
});

function ARCLayout() {
  const initialized = useHostInitialized();
  // useBeforeUnload(
  //   true, // prevent refresh only in prod
  //   'You may lose unsaved work. Are you sure you want to leave?',
  // );
  return (
    <>
      <div className={'arc-page'}>
        <ArcHeader />
        {initialized ? (
          <Outlet />
        ) : (
          <div className={'flex h-screen items-center justify-center'}>
            <Spin size={'large'} />
          </div>
        )}
        <OperatorStatusUpdateForm />
        <RejectCallReasonForm />
      </div>
      <BackgroundTask />
      <Host />
    </>
  );
}
